import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAuthorsQuery, useRepporteursQuery } from "../../../../services";
import FiltrosLista from "../_filtrosLista";
import { SearchSelect } from "../_searchSelect";
import "./index.scss";

const ContentFilters = ({
  filters,
  onPeriodChange,
  period,
  personFilterValue,
  setPersonFilterValue,
}) => {
  const { searchType } = useSelector((state) => state.searchContext);
  const personFilter = searchType.personFilter;

  const [search, setSearch] = useState(personFilterValue || "");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(search);
    }, 300);
    return () => clearTimeout(timeout);
  }, [search]);

  const useQueryFunction =
    searchType?.id === "jurisprudencia" ? useRepporteursQuery : useAuthorsQuery;

  const { data, isLoading } = useQueryFunction({
    search: debouncedSearch,
    enabled:
      searchType.id &&
      (searchType.id === "jurisprudencia" || searchType.id === "doutrinas"),
  });

  const rapporteurOptions = (data?.results || []).map((item) => ({
    label: item,
    value: item,
  }));

  return (
    <div className="pdl_component_filtros_conteudo">
      <FiltrosLista
        items={filters}
        onPeriodChange={onPeriodChange}
        period={period}
      />

      {personFilter && (
        <SearchSelect
          value={personFilterValue}
          placeholder={`Buscar por ${personFilter.label}`}
          options={rapporteurOptions}
          loading={isLoading}
          onSearch={setSearch}
          onSelect={setPersonFilterValue}
        />
      )}
    </div>
  );
};

export default ContentFilters;
